import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [activeModal]);
  const termsContent = <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-58">
      <p data-id="element-59">
        Bienvenido a Sabores que Adelgazan. Al adquirir y utilizar este producto
        digital, aceptas los siguientes términos y condiciones.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-60">
        1. Descripción del producto
      </h3>
      <p data-id="element-61">
        Sabores que Adelgazan es un producto digital en formato PDF que incluye
        un manual, recetas, guías y estrategias relacionadas con hábitos
        alimenticios. No constituye asesoría médica, nutricional ni profesional
        de la salud.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-62">
        2. Uso del contenido
      </h3>
      <p data-id="element-63">
        El contenido es para uso personal e individual. Queda prohibida su
        redistribución, reventa, copia parcial o total, o cualquier uso
        comercial sin autorización expresa por escrito.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-64">3. Resultados</h3>
      <p data-id="element-65">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos de pérdida de peso ni de salud, ya que estos
        dependen de múltiples factores individuales.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-66">
        4. Garantía y reembolsos
      </h3>
      <p data-id="element-67">
        Ofrecemos una garantía de 7 días desde la compra. Si el contenido no
        cumple con tus expectativas, puedes solicitar un reembolso completo
        dentro de ese plazo, sin necesidad de justificación.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-68">
        5. Propiedad intelectual
      </h3>
      <p data-id="element-69">
        Todo el contenido, incluidos textos, recetas, diseños y materiales, está
        protegido por derechos de autor y pertenece exclusivamente a sus
        creadores.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-70">
        6. Limitación de responsabilidad
      </h3>
      <p data-id="element-71">
        No nos hacemos responsables por reacciones, daños o consecuencias
        derivadas del uso del contenido. Recomendamos consultar a un profesional
        de la salud antes de iniciar cualquier cambio significativo en tu
        alimentación.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-72">
        7. Modificaciones
      </h3>
      <p data-id="element-73">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones serán efectivas desde su publicación.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-74">8. Aceptación</h3>
      <p data-id="element-75">
        Al realizar la compra, confirmas que has leído, comprendido y aceptado
        estos términos y condiciones en su totalidad.
      </p>
    </div>;
  const privacyContent = <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-76">
      <p data-id="element-77">
        Tu privacidad es importante para nosotros. Esta política explica cómo
        recopilamos, usamos y protegemos tu información.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-78">
        1. Información que recopilamos
      </h3>
      <p data-id="element-79">
        Al realizar una compra, recopilamos información necesaria para
        procesarla, como nombre, correo electrónico y datos de pago. Los datos
        de pago se procesan a través de plataformas seguras de terceros y no se
        almacenan en nuestros servidores.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-80">
        2. Uso de la información
      </h3>
      <p data-id="element-81">Utilizamos tu información únicamente para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-82">
        <li data-id="element-83">Procesar y entregar tu compra</li>
        <li data-id="element-84">Enviar el producto digital y sus actualizaciones</li>
        <li data-id="element-85">Atender solicitudes relacionadas con tu compra</li>
        <li data-id="element-86">Cumplir obligaciones legales</li>
      </ul>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-87">
        3. Cookies y tecnologías similares
      </h3>
      <p data-id="element-88">
        Utilizamos cookies y píxeles de seguimiento (como Meta Pixel) para
        mejorar la experiencia del sitio, medir el rendimiento de campañas y
        mostrar contenido relevante. Puedes desactivarlas desde la configuración
        de tu navegador.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-89">
        4. Compartir información
      </h3>
      <p data-id="element-90">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros, salvo cuando sea estrictamente necesario para procesar tu
        compra o cuando lo exija la ley.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-91">5. Seguridad</h3>
      <p data-id="element-92">
        Implementamos medidas razonables para proteger tu información. Sin
        embargo, ningún método de transmisión por internet es 100% seguro.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-93">6. Tus derechos</h3>
      <p data-id="element-94">
        Tienes derecho a acceder, corregir o solicitar la eliminación de tus
        datos personales en cualquier momento, conforme a la legislación
        aplicable.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-95">
        7. Menores de edad
      </h3>
      <p data-id="element-96">
        Este producto y sitio están destinados a personas mayores de 18 años. No
        recopilamos intencionalmente información de menores.
      </p>

      <h3 className="text-lg font-bold text-gray-900 pt-2" data-id="element-97">
        8. Cambios en esta política
      </h3>
      <p data-id="element-98">
        Podemos actualizar esta política periódicamente. La versión vigente
        siempre estará disponible en este sitio.
      </p>
    </div>;
  return <>
      <footer className="bg-gray-900 text-gray-400 py-10 text-center text-sm" data-id="element-99">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
          <p className="mb-4" data-id="element-101">
            © {new Date().getFullYear()} Sabores que Adelgazan. Todos los
            derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-102">
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-103">
              Términos y Condiciones
            </button>
            <span className="text-gray-700" data-id="element-104">|</span>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-105">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-[fadeIn_0.2s_ease-out]" onClick={() => setActiveModal(null)} role="dialog" aria-modal="true" data-id="element-106">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-107">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-warm-beige/30" data-id="element-108">
              <h2 className="text-xl md:text-2xl font-serif font-bold text-warm-brown" data-id="element-109">
                {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-warm-beige/60 transition-colors text-gray-600 hover:text-gray-900" aria-label="Cerrar" data-id="element-110">
                <X size={22} data-id="element-111" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 py-6 text-base" data-id="element-112">
              {activeModal === 'terms' ? termsContent : privacyContent}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-end" data-id="element-113">
              <button onClick={() => setActiveModal(null)} className="bg-olive-green hover:bg-olive-green-dark text-white font-bold py-2 px-6 rounded-full transition-colors" data-id="element-114">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}